module.exports = __webpack_public_path__ + "img/HSIHKD.887bfffc.png";